export type ApiResponse<T = unknown> = {
    Data: T;
    Status: number;
    Errors?: ApiError[];
    Warnings?: ApiWarning[];
};
export type ApiWarning = {
    Code: number;
    Message: string;
};
export const API_WARNING_CODES = {
    MemberInactive: 25, // the member exists but is inactive
} as const;
export type ApiError = {
    Code: number;
    Message: string;
}
export enum ApiStatus {
    Success = 0,
    Error = -1,
}